import { getAllRefStatus } from '../../../../../../utils/api/appListAPI';
import {
    fetchAllRefStatusOption,
    fetchAllRefStatusOptionError,
} from './myIncidentsFilterSlice';

export const fetchStateThunk = () => async (dispatch) => {
    try {
        // Fetch reference status data
        const refStatusResponse = await getAllRefStatus({ pagination: 'false',sort:'description_tx' ,order: 'asc' });
        if (refStatusResponse && Array.isArray(refStatusResponse)) {
            const refStatusOptions = [
                { value: 'Not Closed', label: 'NOT CLOSED' },
                { value: 'ALL', label: 'ALL' },
                ...refStatusResponse.map((item) => ({
                    value: item?.ref_status_cd,
                    label: item?.description_tx,
                })),
            ];
            dispatch(fetchAllRefStatusOption(refStatusOptions)); // Store processed refStatus options
        } else {
            throw new Error('Invalid or empty response from getAllRefStatus API');
        }
    } catch (error) {
        dispatch(fetchAllRefStatusOptionError(error));
    }
};
